import type { IconSvgObject } from './types';

const Pen01Icon: IconSvgObject = [
  ["path", { d: "M3.5 17.1213V20.5H6.87868C7.2765 20.5 7.65804 20.342 7.93934 20.0607L20.06 7.93934C20.6458 7.35355 20.6458 6.40381 20.06 5.81802L18.1813 3.93934C17.5955 3.35355 16.6458 3.35355 16.06 3.93934L3.93934 16.0607C3.65804 16.342 3.5 16.7235 3.5 17.1213Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5002 6.49902L17.5002 10.499", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Pen01Icon;
